import MyPunchesPage from "./MyPunchesPage";

export default {
    list: MyPunchesPage,
    create: MyPunchesPage,
};